<template>
  <div
    v-if="isVisible"
    class="z-50 flex items-center w-full px-5 py-4 text-sm"
    :class="[`v-alert-banner-${bannerType}`]"
    data-testid="v-notification-banner"
  >
    <CheckCircleIcon v-if="bannerType === 'success'" class="flex-shrink-0 w-6 mr-4" />
    <XCircleIcon v-else-if="bannerType === 'danger'" class="flex-shrink-0 w-6 mr-4" />
    <ExclamationCircleIcon v-else-if="bannerType === 'warning'" class="flex-shrink-0 w-6 mr-4" />
    <InformationCircleIcon v-else class="flex-shrink-0 w-6 mr-4" />
    <div class="flex items-center flex-grow text-sm font-medium text-gray-900">
      <div class="w-full">
        <slot />
      </div>
    </div>
    <div class="text-gray-900 cta">
      <slot name="dismiss">
        <XMarkIcon class="w-6 cursor-pointer" @click="$emit('clear-banner')" />
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { XMarkIcon, CheckCircleIcon, XCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/vue/24/solid'

export type BannerType = 'success' | 'danger' | 'info' | 'warning'

export interface Banner {
  type: BannerType
  message: string
  timeout: number
  persistThroughNav: boolean
}

defineEmits(['clear-banner'])

defineProps({
  bannerType: {
    type: String as PropType<BannerType>,
    default: 'info',
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
  timeout: {
    type: Number,
    required: false,
    default: 0,
  },
})
</script>

<style lang="stylus" scoped>
.v-alert-banner-warning
  @apply bg-gold-100 text-gold-50

.v-alert-banner-danger
  @apply bg-red-100 text-red-800

.v-alert-banner-success
  @apply bg-copper-50 text-copper-700

.v-alert-banner-info
  @apply bg-blue-100 text-blue-700
</style>
